import React from 'react';
import { useOutletContext } from 'react-router-dom';
import AccountSettingsPage from '../components/AccountSettingsPage';
import CardsPage from '../components/CardsPage';
import ContactPage from '../components/ContactPage';
import DashboardPage from '../components/DashboardPage';
import DepositPage from '../components/DepositPage';
import ExchangePage from '../components/ExchangePage';
import TransactionsPage from '../components/TransactionsPage';
import VerificationPage from '../components/VerificationPage';
import WithdrawPage from '../components/WithdrawPage';

export function DashboardRoute() {
  const { navigateTo, user } = useOutletContext();
  return <DashboardPage user={user} navigateTo={navigateTo} />;
}

export function CardsRoute() {
  const { cardsPageKey, formatDate, setPathCompat, setUser, user } = useOutletContext();
  return <CardsPage key={cardsPageKey} user={user} setUser={setUser} formatDate={formatDate} setPath={setPathCompat} />;
}

export function TransactionsRoute() {
  return <TransactionsPage />;
}

export function DepositRoute() {
  const { setUser, user } = useOutletContext();
  return <DepositPage user={user} setUser={setUser} />;
}

export function ExchangeRoute() {
  const { formatDate, setUser, user } = useOutletContext();
  return <ExchangePage user={user} setUser={setUser} formatDate={formatDate} />;
}

export function ContactRoute() {
  return <ContactPage />;
}

export function WithdrawRoute() {
  const { setPathCompat, setUser, user } = useOutletContext();
  return <WithdrawPage user={user} setUser={setUser} setPath={setPathCompat} />;
}

export function VerificationRoute() {
  const { setActiveMenu, setPathCompat } = useOutletContext();
  return <VerificationPage setPath={setPathCompat} setMenu={setActiveMenu} />;
}

export function AccountSettingsRoute() {
  const { setPathCompat, user } = useOutletContext();
  return <AccountSettingsPage user={user} setPath={setPathCompat} />;
}
